import { Box, Typography, Avatar, Chip } from '@mui/material';
import { useSelector } from 'react-redux';
import { tokens } from '../../theme/theme';

export default function PortalTopbar() {
  const { orgName, email } = useSelector((s) => s.portalAuth);

  return (
    <Box
      sx={{
        height: 64, px: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        borderBottom: `1px solid ${tokens.border}`, backgroundColor: tokens.bg.default
      }}
    >
      <Box>
        <Typography variant="body2" sx={{ color: tokens.text.muted, fontSize: '0.75rem' }}>Signed in as</Typography>
        <Typography variant="body2" sx={{ color: tokens.text.primary, fontWeight: 600, fontSize: '0.85rem' }}>{orgName}</Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Chip
          label="Client Access" size="small"
          sx={{ color: tokens.brand.main, border: `1px solid ${tokens.brand.main}`, backgroundColor: tokens.brand.glow, fontWeight: 600 }}
        />
        <Avatar sx={{ width: 32, height: 32, bgcolor: tokens.brand.dim, fontSize: '0.75rem' }}>
          {orgName?.slice(0, 2).toUpperCase()}
        </Avatar>
      </Box>
    </Box>
  );
}
